import { render, staticRenderFns } from "./developPage.vue?vue&type=template&id=afcb7108&"
import script from "./developPage.vue?vue&type=script&lang=js&"
export * from "./developPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports